'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailCMF = exports.isCrmMessage = exports.isCommonMessageFormat = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../constants/messageTypes');

var _messageTypes2 = require('../../pubnub-message/constants/messageTypes');

var _commonMessageFormatGetters = require('./commonMessageFormatGetters');

var _contentTypes = require('../constants/contentTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isCommonMessageFormat = exports.isCommonMessageFormat = function isCommonMessageFormat(message) {
  return (0, _get2.default)(_messageTypes2.MESSAGE_TYPE_ID, message) === _messageTypes.COMMON_MESSAGE;
};

var isCrmMessage = exports.isCrmMessage = function isCrmMessage(message) {
  return isCommonMessageFormat(message) && (0, _commonMessageFormatGetters.getStatusSource)(message) === _contentTypes.CRM;
};

var isEmailCMF = exports.isEmailCMF = function isEmailCMF(message) {
  return isCommonMessageFormat(message) && (0, _commonMessageFormatGetters.getStatusSource)(message) === _contentTypes.EMAIL;
};